RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _) {

    'use strict';

    selectors.PostType = RivalIQ.views.Select.extend({
        name: 'type',

        onChange: function (type) {
            const me = this;

            // NOTE if are using aggregate metrics this would need to be
            // me.dashboardModel.setBaseMetric
            me.dashboardModel.setProps({
                type: type
            });
        },

        getPostTypeOptions: function () {
            // TODO do we need a canonical list or should we load from results?
            return [
                {
                    id: undefined,
                    name: 'All Media'
                },
                {
                    id: 'gif',
                    name: 'GIF'
                },
                {
                    id: 'photo',
                    name: 'Photo'
                },
                {
                    id: 'link',
                    name: 'Link'
                },
                {
                    id: 'status',
                    name: 'Status Update'
                },
                {
                    id: 'video',
                    name: 'Video'
                }
            ];
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);

            me.selected = me.dashboardModel.getProp('type');
            me.items = me.getPostTypeOptions();
        }
    });
});
